import React from "react";
import { AccountManagementPage } from "components/pages";

export interface AccountManagementProps {};

const AccountManagement: React.FC<AccountManagementProps> = () => (
    <AccountManagementPage />
)

export default AccountManagement;